import { render, staticRenderFns } from "./Esboco.vue?vue&type=template&id=5d8391a5"
import script from "./Esboco.vue?vue&type=script&lang=js"
export * from "./Esboco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports